
import { useEffect, useState } from "react";
import url from "../api/url";
import CardContenedor from "../components/CardContenedor";
import { useAdmin } from "../hooks/useAdmin";
import { ListItem } from "../components/ListItem";
import ModalInfoEmpleado from "../components/ModalInfoEmpleado";

export default function PaginaEmpleados() {

    const { empleados, cargando } = useAdmin()
    const { url_excel } = url()
    const [empleadosEncontrados, setEmpleadosEncontrados] = useState([]);


    function HeaderListaEmpleados() {
        return (
            <>
                <p className="lead">
                    {empleadosEncontrados?.length ?? 0} empleados registrados
                </p>

                {/*<Link to="/reportes">reportes</Link> */}

                <a className="btn btn-primary btn-sm mb-4" href={url_excel} target="_blank" rel="noreferrer">
                    Descargar <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-file-earmark-excel" viewBox="0 0 16 16">
                        <path d="M5.884 6.68a.5.5 0 1 0-.768.64L7.349 10l-2.233 2.68a.5.5 0 0 0 .768.64L8 10.781l2.116 2.54a.5.5 0 0 0 .768-.641L8.651 10l2.233-2.68a.5.5 0 0 0-.768-.64L8 9.219l-2.116-2.54z" />
                        <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z" />
                    </svg>
                </a>



            </>
        )
    }

    const MensajeNoHayEmpleados = () => {
        if (cargando) {
            return <></>
        }

        if (empleadosEncontrados.length === 0) {
            return (
                <div className="alert alert-warning" role="alert">
                    No se encontró a ningún empleado.
                </div>
            )
        } else {
            return <></>
        }
    }

    const buscarEmpleados = (busqueda) => {
        busqueda = busqueda.target.value; //obtenemos el valor ingresado en el input con 'target.value'

        if (busqueda) {

            const limpiarTexto = texto =>
                texto.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

            // Expresión regular para buscar coincidencias
            const regex = new RegExp(limpiarTexto(busqueda), 'i');

            // Filtrar los datos
            const resultados = empleados.filter(item => regex.test(limpiarTexto(item.nombre)) || regex.test(limpiarTexto(item.apellido)));

            setEmpleadosEncontrados(resultados);

        } else {
            setEmpleadosEncontrados(empleados); //si no se busca nada se guardan los datos de todos los empleados
        }
    }



    function ListaDeEmpleados() {
        return (
            <>


                {cargando &&
                    <div className="text-center">
                        <div className="spinner-border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                }
                <MensajeNoHayEmpleados />
                <ListItem empleados={empleadosEncontrados} />

                {/* <ModalEmpleados/> */}
                <ModalInfoEmpleado />
            </>
        )
    }


    // useEffect
    useEffect(() => {
        setEmpleadosEncontrados(empleados);
        // eslint-disable-next-line
    }, [cargando]) //cuando 'cargando' cambie a 'false' ya se habrán obtenido los empleados, entonces se guardan en el useState 'empleadosEncontrados'



    return (
        <CardContenedor>
            <>
                <HeaderListaEmpleados />
                {/* Buscador de empleados */}
                <div className="input-group mb-4">
                    <span className="input-group-text" id="basic-addon1">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-search" viewBox="0 0 16 16">
                            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                        </svg>
                    </span>
                    <input type="text" className="form-control" placeholder="Buscar empleados" onChange={buscarEmpleados} aria-describedby="basic-addon1" />
                </div>
                <ListaDeEmpleados />
            </>
        </CardContenedor>
    )
}
